<template>
    <div class="d-flex flex-fill">
        <div v-if="mode === 'view'" class="d-flex flex-fill">
            {{ data == null ? '-' : value }}
        </div>
        <div v-if="mode === 'edit' || mode === 'create'" class="d-flex flex-fill">
            <input ref="input" :type="type" v-on:keydown="onKeyDown" :value="data" @change="onValueChanged($event.target.value)" class="form-control" :placeholder="placeholder" />
        </div>
    </div>
</template>

<script>
    import EventBus from './bus.js';
    import * as $ from 'jquery';

    export default {
        name: 'vs-input',
        props: ['data', 'header', 'headerKey', 'mode', 'placeholder', 'type'],
        data() {
            return {
                lastValue: ''
            };
        },
        mounted() {
            EventBus.$on('onResetHeaderFormsValue', () => {
                $(this.$refs.input).val('');
                this.onValueChanged('');
            });
        },
        methods: {
            onValueChanged(val) {
                this.$emit('dataChanged', this.headerKey, val);
            },
            onKeyDown(event) {
                if(this.type === 'number' && event.key === 'e') {
                    event.preventDefault();
                    return;
                }

                this.$nextTick(() => {
                    if(event.target.value === this.lastValue) {
                        return;
                    }

                    this.onValueChanged(event.target.value);
                    this.lastValue = event.target.value;
                });
            }
        },
        computed: {
            value() {
                if(this.header.formatCurrency !== undefined && this.header.formatCurrency) {
                    return this.$options.filters.formatCurrency(this.data);
                }

                if(this.header.formatGregorianDateToJalaali !== undefined && this.header.formatGregorianDateToJalaali) {
                    return this.$options.filters.formatGregorianDateToJalaali(this.data);
                }

                return this.data;
            }
        }
    }
</script>

<style scoped>

</style>
